import PersistentData from "../PersistentData";
import ClinicService from "./ClinicService";
import AccountService from "./AccountService";
import Service from "../Service";
import {saveAs} from "file-saver";


const reminderRequired = ['date', 'description', 'patientId'];
const account = new AccountService();
const service = new Service();

function isValid(reminder) {
	for (let i = 0; i < reminderRequired.length; i++) {
		let prop = reminderRequired[i];
		if (reminder[prop] === undefined) {
			return false;
		}
	}
	return true;
}

function getLatestAssessment(assessments) {
	let aid = -1;
	let ass = null;
	for (let i = 0; i < assessments.length; i++) {
		let a = assessments[i];
		if (a.assessmentId > aid) {
			aid = a.assessmentId;
			ass = a;
		}
	}
	return ass;
}

export default class FollowUpService {

	static CreateReminder(reminder) {
		/*
			date,
			description,
			patientId,
			doctorId,
			clinicId
		*/
		return new Promise((resolve, reject) => {
			if (isValid(reminder)) {
				let cache = this.GetCache(reminder.doctorId, reminder.clinicId);// new PersistentData(ClinicService.GetDrCachePath(reminder.doctorId, reminder.clinicId) + '/FollowUpReminder');
				let reminders = cache.getAll() || [];
				let reminderId = reminders.length;
				reminder.id = reminderId;
				reminder.clinicId = reminder.clinicId || account.clinicId;
				reminder.doctorId = reminder.doctorId || account.userId;
				cache.setData(reminderId, reminder);

				resolve(reminder);
			} else {
				reject(reminder);
			}
		});
	}

	static GetCache(doctorId, clinicId) {
		return new PersistentData(ClinicService.GetDrCachePath(doctorId, clinicId) + '/FollowUpReminder');
	}

	static GetAll(doctorId, clinicId) {
		return new Promise((resolve, reject) => {
			resolve(this.GetCache(doctorId, clinicId).getAll());
		})
	}

	static GetFollowUps() {
		return service.request('Followups', {
			cache_path: ClinicService.GetCachePath(),
			//cache_key: 'FollowUps',
			//cache_lifespan: 10000,// 10 second cache // (1000 * 60) * 5, //5min life span
			cache_dataTransform: (json) => {
				let o = {};
				for (let i = 0; i < json.length; i++) {
					let fu = json[i];
					o[fu.clientId] = fu;
				}
				return o;
			}
		});
	}

	static GetUserFollowUps(userId, all = false) {
		//console.log('GetUserFollowUps:', userId);
		return FollowUpService.GetFollowUps().then((json) => {
			let user = json[userId];
			if (user) {
				if(all) return user.assessments;
				let assessment = getLatestAssessment(user.assessments);
				if (assessment) {
					return assessment.followups.map((f) => {
						f.assessmentId = assessment.assessmentId;
						return f;
					});
				}
			}
			return null;
		});
	}

	static GetDocument(opts) {
		return service.request('FollowupDocuments', {
			post: opts,
			returnType: 'raw'
		}).then((rsp) => {
			//console.log("Response Headers:", rsp.headers);
			return rsp.blob();
			/*rsp.blob().then((blob) => {
				saveAs(blob, "mydoc.doc");
			})

			for (var pair of rsp.headers.entries()) {
				console.log("HRes Headers - " + pair[0]+ ': '+ pair[1]);
			}*/
		})
	}

	static SaveDocument(opts, filename) {
		return FollowUpService.GetDocument(opts).then((doc) => {
			saveAs(doc, filename);
			return doc;
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/services/FollowUpService.js